import { defineMessages } from 'react-intl'

export default defineMessages({
  cloneNotification: {
    id: 'SpacePublisherPage.PublisherNotificationList.CloneNotification',
    defaultMessage: 'Clone Notification'
  },
  createNotification: {
    id: 'SpacePublisherPage.PublisherNotificationList.CreateNotification',
    defaultMessage: 'Create Notification'
  },
  createdBy: {
    id: 'SpacePublisherPage.PublisherNotificationList.CreatedBy',
    defaultMessage: 'Created By'
  },
  category: {
    id: 'SpacePublisherPage.PublisherNotificationList.Category',
    defaultMessage: 'Category'
  },
  deleteNotification: {
    id: 'SpacePublisherPage.PublisherNotificationList.DeleteNotification',
    defaultMessage: 'Delete Notification'
  },
  deletingNotification: {
    id: 'SpacePublisherPage.PublisherNotificationList.DeletingNotification',
    defaultMessage: 'Deleting Notification'
  },
  editNotification: {
    id: 'SpacePublisherPage.PublisherNotificationList.EditNotification',
    defaultMessage: 'Edit Notification'
  },
  hideDeleted: {
    id: 'SpacePublisherPage.PublisherNotificationList.HideArchived',
    defaultMessage: 'Hide Deleted'
  },
  manageSources: {
    id: 'SpacePublisherPage.PublisherNotificationList.ManageSources',
    defaultMessage: 'Manage Sources'
  },
  notifications: {
    id: 'SpacePublisherPage.PublisherNotificationList.Notifications',
    defaultMessage: 'notifications'
  },
  published: {
    id: 'SpacePublisherPage.PublisherNotificationList.Published',
    defaultMessage: 'Published'
  },
  recallNotification: {
    id: 'SpacePublisherPage.PublisherNotificationList.RecallNotification',
    defaultMessage: 'Recall Notification'
  },
  recallingNotification: {
    id: 'SpacePublisherPage.PublisherNotificationList.RecallingNotification',
    defaultMessage: 'Recalling Notification'
  },
  recentNotifications: {
    id: 'SpacePublisherPage.PublisherNotificationList.RecentNotifications',
    defaultMessage: 'Recent Notifications'
  },
  showDeleted: {
    id: 'SpacePublisherPage.PublisherNotificationList.ShowArchived',
    defaultMessage: 'Show Deleted'
  },
  viewAnalytics: {
    id: 'SpacePublisherPage.PublisherNotificationList.ViewAnalytics',
    defaultMessage: 'View Analytics'
  },
  status: {
    id: 'SpacePublisherPage.PublisherNotificationList.Status',
    defaultMessage: 'Status'
  },
  title: {
    id: 'SpacePublisherPage.PublisherNotificationList.Title',
    defaultMessage: 'Title'
  },
  willBeRecalled: {
    id: 'SpacePublisherPage.PublisherNotificationList.ConfirmRecallNotificationMessage',
    defaultMessage: 'This notification will be recalled'
  },
  willBeRemoved: {
    id: 'SpacePublisherPage.PublisherNotificationList.ConfirmDeleteNotificationMessage',
    defaultMessage: 'This notification will be removed from your space'
  },
  selectNotification: {
    id: 'SpacePublisherPage.PublisherNotificationList.Results',
    defaultMessage: 'Results'
  }
})
